/**
 * Desi Firms Design System - Animation Tokens
 */

// Duration values
export const durations = {
  instant: '0ms',
  fastest: '50ms',
  faster: '100ms',
  fast: '150ms',
  normal: '200ms',
  slow: '300ms',
  slower: '400ms',
  slowest: '500ms',
};

// Easing functions
export const easings = {
  // Standard easings
  linear: 'linear',
  ease: 'ease',
  easeIn: 'ease-in',
  easeOut: 'ease-out',
  easeInOut: 'ease-in-out',

  // Custom cubic-bezier curves
  easeInQuad: 'cubic-bezier(0.55, 0.085, 0.68, 0.53)',
  easeOutQuad: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  easeInOutQuad: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',

  easeInCubic: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
  easeOutCubic: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
  easeInOutCubic: 'cubic-bezier(0.645, 0.045, 0.355, 1)',

  // Bounce and elastic
  easeOutBack: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
  easeInBack: 'cubic-bezier(0.36, 0, 0.66, -0.56)',

  // Spring-like
  spring: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
};

// Pre-defined transitions
export const transitions = {
  // Default transition
  default: `all ${durations.normal} ${easings.easeOut}`,

  // Specific property transitions
  colors: `color ${durations.fast} ${easings.ease}, background-color ${durations.fast} ${easings.ease}, border-color ${durations.fast} ${easings.ease}`,
  opacity: `opacity ${durations.normal} ${easings.ease}`,
  transform: `transform ${durations.normal} ${easings.easeOut}`,
  shadow: `box-shadow ${durations.normal} ${easings.ease}`,

  // Component-specific
  button: `all ${durations.fast} ${easings.easeOut}`,
  input: `border-color ${durations.fast} ${easings.ease}, box-shadow ${durations.fast} ${easings.ease}`,
  card: `transform ${durations.normal} ${easings.easeOut}, box-shadow ${durations.normal} ${easings.ease}`,
  modal: `opacity ${durations.slow} ${easings.easeOut}, transform ${durations.slow} ${easings.spring}`,
  dropdown: `opacity ${durations.fast} ${easings.easeOut}, transform ${durations.fast} ${easings.easeOut}`,
  tooltip: `opacity ${durations.faster} ${easings.ease}`,

  // None (for reduced motion)
  none: 'none',
};

// Keyframe animation definitions (for CSS-in-JS)
export const keyframes = {
  fadeIn: `
    from { opacity: 0; }
    to { opacity: 1; }
  `,
  fadeOut: `
    from { opacity: 1; }
    to { opacity: 0; }
  `,
  slideInUp: `
    from { transform: translateY(10px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  `,
  slideInDown: `
    from { transform: translateY(-10px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  `,
  slideInLeft: `
    from { transform: translateX(-10px); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  `,
  slideInRight: `
    from { transform: translateX(10px); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  `,
  scaleIn: `
    from { transform: scale(0.95); opacity: 0; }
    to { transform: scale(1); opacity: 1; }
  `,
  spin: `
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  `,
  pulse: `
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  `,
  bounce: `
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  `,
  shake: `
    0%, 100% { transform: translateX(0); }
    25% { transform: translateX(-5px); }
    75% { transform: translateX(5px); }
  `,
  shimmer: `
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  `,
};

export default {
  durations,
  easings,
  transitions,
  keyframes,
};
